import { Input, Directive, ElementRef } from '@angular/core';

@Directive({
	selector: '[hidden]',
	standalone: false,
})
export class HiddenDirective {
	constructor(private el: ElementRef) {}

	@Input()
	set hidden(value: string | boolean | number) {
		if (
			!(
				value === null ||
				value === undefined ||
				value === 'false' ||
				value === false ||
				value === 0
			)
		) {
			this.el.nativeElement.remove();
		}
	}
}
